"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJGeneralMenuScene = void 0;
const CGJCycleGraphic_1 = require("./CGJCycleGraphic");
const CGJGameScene_1 = require("./CGJGameScene");
const CGJCycle_1 = require("./CGJCycle");
const CGJStage_1 = require("./CGJStage");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
const KHSimpleListMenu_1 = require("./KH/Menu/KHSimpleListMenu");
const KHEventHandler_1 = require("./KH/KHEventHandler");
const CGJText_1 = require("./CGJText");
const KHMenuOption_1 = require("./KH/Menu/KHMenuOption");
const KHMenuLinkOption_1 = require("./KH/Menu/KHMenuLinkOption");
const KHListInputHandler_1 = require("./KH/Menu/KHListInputHandler");
const KHUnifiedInput_1 = require("./KH/Input/KHUnifiedInput");
const KHInputProviderController_1 = require("./KH/Input/KHInputProviderController");
const KHInputKeyCompeting_1 = require("./KH/Input/KHInputKeyCompeting");
const KHInputKeyRepeating_1 = require("./KH/Input/KHInputKeyRepeating");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHInputKeyFromAxis_1 = require("./KH/Input/KHInputKeyFromAxis");
const KHInputSet_1 = require("./KH/Input/KHInputSet");
class CGJGeneralMenuScene extends Phaser.Scene {
    constructor(key, showCycle = true) {
        super(key);
        this.showCycle = showCycle;
    }
    init(data) {
        this.init_data = data;
    }
    onCreate() {
        return new KHMenuSpec_1.KHMenuSpec("", [], null);
    }
    create() {
        this.options = [];
        this.idx = 0;
        this.background = null;
        this.space = null;
        this.cycle = null;
        this.emitter = new KHEventHandler_1.KHEventHandler([CGJGeneralMenuScene.EVENT_RESIZE]);
        let w = Number(this.game.config.width);
        let h = Number(this.game.config.height);
        this.resize(w, h);
        this.tickSound = this.sound.add('Tick');
        this.menuSpec = this.onCreate();
        this.listMenu = new KHSimpleListMenu_1.KHSimpleListMenu(this, KHInputScene_1.KHInputScene.SharedInput, CGJGeneralMenuScene.makeListInputHandler(this), this.menuSpec, new Phaser.Geom.Rectangle(0, 0, w, h), [], (menuOption, onPointerOver, onPointerOut, onPointerLeft, onPointerRight, onSelect) => {
            let item = new CGJText_1.CGJText(this, this.w, this.h, menuOption.extras["x"], menuOption.extras["y"], menuOption, menuOption.extras["fontSize"], onPointerOver, onPointerOut, onPointerLeft, onPointerRight);
            this.emitter.registerCallback(CGJGeneralMenuScene.EVENT_RESIZE, (data) => {
                item.resize(data.width, data.height);
            });
            return item;
        }, null, null);
    }
    resume() {
        console.log("resume");
    }
    static makeListInputHandler(scene) {
        const inputSet = new KHInputSet_1.KHInputSet("menu");
        const axisThreshold = 0.5;
        let left = KHUnifiedInput_1.KHUnifiedInput.GetCombinedInput(inputSet, [
            new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.PadAxis.LeftStickX, 0)), -axisThreshold),
            ...KHUnifiedInput_1.KHUnifiedInput.GetControllerInputs([KHInputProviderController_1.PadInput.Left]),
            ...KHUnifiedInput_1.KHUnifiedInput.GetKeyboardInputs([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.A])
        ]);
        let right = KHUnifiedInput_1.KHUnifiedInput.GetCombinedInput(inputSet, [
            new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.PadAxis.LeftStickX, 0)), axisThreshold),
            ...KHUnifiedInput_1.KHUnifiedInput.GetControllerInputs([KHInputProviderController_1.PadInput.Right, KHInputProviderController_1.PadInput.Start, KHInputProviderController_1.PadInput.A]),
            ...KHUnifiedInput_1.KHUnifiedInput.GetKeyboardInputs([Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.D, Phaser.Input.Keyboard.KeyCodes.ENTER])
        ]);
        let up = KHUnifiedInput_1.KHUnifiedInput.GetCombinedInput(inputSet, [
            new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.PadAxis.LeftStickY, 0)), -axisThreshold),
            ...KHUnifiedInput_1.KHUnifiedInput.GetControllerInputs([KHInputProviderController_1.PadInput.Up]),
            ...KHUnifiedInput_1.KHUnifiedInput.GetKeyboardInputs([Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.W])
        ]);
        let down = KHUnifiedInput_1.KHUnifiedInput.GetCombinedInput(inputSet, [
            new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.PadAxis.LeftStickY, 0)), axisThreshold),
            ...KHUnifiedInput_1.KHUnifiedInput.GetControllerInputs([KHInputProviderController_1.PadInput.Down]),
            ...KHUnifiedInput_1.KHUnifiedInput.GetKeyboardInputs([Phaser.Input.Keyboard.KeyCodes.DOWN, Phaser.Input.Keyboard.KeyCodes.S])
        ]);
        const competingLeft = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, left, right, false), 200, 200);
        const competingRight = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, right, left, true), 200, 200);
        const competingUp = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, up, down, false), 200, 200);
        const competingDown = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, down, up, true), 200, 200);
        return new KHListInputHandler_1.KHListInputHandler(scene, competingLeft, competingRight, competingUp, competingDown, KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.BACKSPACE], [KHInputProviderController_1.PadInput.B]), inputSet);
    }
    resize(w, h) {
        this.w = w;
        this.h = h;
        this.cameras.resize(w, h);
        if (this.rect) {
            this.rect.width = w;
            this.rect.height = h;
        }
        this.emitter.emitEvent(CGJGeneralMenuScene.EVENT_RESIZE, { width: w, height: h });
        if (!this.space) {
            this.space = this.add.image(0, 0, 'Space').setDepth(-2).setOrigin(0).setTint(0x888888);
        }
        if (!this.background && this.showCycle) {
            const size = h * 4 / 5;
            this.background = new CGJStage_1.CGJStage(this, CGJGameScene_1.CGJSeason.Summer, (w - size) / 2, (h - size) / 2, size, size).setDepth(-1);
            this.add.existing(this.background);
        }
        if (!this.cycle && this.showCycle) {
            this.cycle = new CGJCycleGraphic_1.CGJCycleGraphic(this, w / 2, h / 2, h / 3 * w / 1920, new CGJCycle_1.CGJCycle(null, [
                new CGJCycle_1.CGJCycleElement("Fall", 2000, 0x6C2F00, null, () => this.setSeason(CGJGameScene_1.CGJSeason.Fall), null, null, [
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0x522300, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0x853900, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                        ]),
                    ]),
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0x522300, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0x853900, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0x522300, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0x853900, null, null, null, null),
                            ]),
                        ]),
                    ]),
                ]),
                new CGJCycle_1.CGJCycleElement("Winter", 2000, 0xB3DAF1, null, () => this.setSeason(CGJGameScene_1.CGJSeason.Winter), null, null, [
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xBDE7FF, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xA0C4D9, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                        ]),
                    ]),
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xBDE7FF, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xA0C4D9, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xBDE7FF, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xA0C4D9, null, null, null, null),
                            ]),
                        ]),
                    ]),
                ]),
                new CGJCycle_1.CGJCycleElement("Spring", 2000, 0xF3A8BC, null, () => this.setSeason(CGJGameScene_1.CGJSeason.Spring), null, null, [
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xFFB0C5, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xD996A7, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                        ]),
                    ]),
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xFFB0C5, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xD996A7, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xFFB0C5, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xD996A7, null, null, null, null),
                            ]),
                        ]),
                    ]),
                ]),
                new CGJCycle_1.CGJCycleElement("Summer", 2000, 0xE0E300, null, () => this.setSeason(CGJGameScene_1.CGJSeason.Summer), null, null, [
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xF8FC00, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xC6C900, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                        ]),
                    ]),
                    new CGJCycle_1.CGJCycle(null, [
                        new CGJCycle_1.CGJCycleElement("", 500, 0xF8FC00, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                        ]),
                        new CGJCycle_1.CGJCycleElement("", 500, 0xC6C900, null, null, null, null, [
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                            new CGJCycle_1.CGJCycle(null, [
                                new CGJCycle_1.CGJCycleElement("", 125, 0xF8FC00, null, null, null, null),
                                new CGJCycle_1.CGJCycleElement("", 125, 0xC6C900, null, null, null, null),
                            ]),
                        ]),
                    ]),
                ]),
            ]), false);
            this.add.existing(this.cycle);
            this.add.sprite(w / 2, h / 2, 'StoneHead').setScale(8);
        }
    }
    setSeason(season) {
        this.background.setSeason(season);
    }
    addText(cx, cy, option_text, size = .1) {
        return KHMenuOption_1.KHMenuOption.JustText(option_text, { "x": cx, "y": cy, "fontSize": size });
    }
    addLink(cx, cy, option_text, url, size = .1) {
        return new KHMenuLinkOption_1.KHMenuLinkOption(option_text, url, null, true, { "x": cx, "y": cy, "fontSize": size });
    }
    addClickableOption(cx, cy, option_text, callback, size = .1) {
        return new KHMenuOption_1.KHMenuOption(option_text, null, true, callback, null, { "x": cx, "y": cy, "fontSize": size });
    }
    addConditionalBackOption() {
        if (this.init_data && this.init_data.previous_scene) {
            return this.addClickableOption(.5, .9, "Back", () => { this.startScene(this.init_data.previous_scene, null, false, true); });
        }
        return null;
    }
    startScene(name, data = {}, disallow_back = false, is_going_back = false) {
        if (!data) {
            data = {};
        }
        if (is_going_back) {
            data = this.init_data.init_data;
        }
        else if (!disallow_back) {
            const back_data = this.init_data ? this.init_data : {};
            data.previous_scene = this.scene.key;
            data.init_data = back_data;
        }
        this.scene.start(name, data);
    }
    update(now, delta) {
        if (this.cycle)
            this.cycle.cycle.update(now, delta);
        this.listMenu.update(now);
    }
}
exports.CGJGeneralMenuScene = CGJGeneralMenuScene;
CGJGeneralMenuScene.EVENT_RESIZE = "r";
